<template>
  <ExternalQueryList
      headline="Search Suggestions"
      endpoint="/api/v2/search-suggestions"
      :endpoint-filters="{portal_id: portal.id}"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => true"
      :can-update="() => true"
      :checkbox-column-width="2"
      :button-column-width="2"
      @show="searchSuggestion => $router.push(getUrl(searchSuggestion))"
  >
    <template v-slot:default="{ row: searchSuggestion }">
      <td>
        <router-link :to="getUrl(searchSuggestion)">
          {{ searchSuggestion.attributes.text }}
        </router-link>
      </td>

      <td>
          {{ searchSuggestion.attributes.path }}
      </td>
    </template>

    <template v-slot:headline-right>
      <router-link
          class="btn btn-white btn-sm"
          style="margin-top: 4px;"
          :to="'/portals/' + portal.id + '/content/search-suggestions/create'"
      >
        <i class="fa fa-plus"></i> Create
      </router-link>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {ExternalQueryList},

  props: {
    portal: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 10, text: 'Text'},
        {width: 10, text: 'Path'},
      ]
    },

    filters() {
      return [
        [
          {
            width: 20,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    getUrl(searchSuggestion) {
      return '/portals/' + this.portal.id + '/content/search-suggestions/' + searchSuggestion.id + '/edit'
    }
  }
}
</script>
